/**
 * 「权限不足」视图（C1 Phase 3）。
 *
 * 要求（设计稿 §3.2-4）：页面显示「权限不足：<功能名>」并**指引联系管理员**，
 * **不显示原始错误码**；原码只进 `title`（hover / 排障用）。
 *
 * ⚠️ 这是**展示层**：真正的拒绝在服务端（Phase 2A/2B 中间件，fail-closed）。
 * 前端只是"不让用户走到一个必然 403 的页面"。
 */

import type { ReactElement } from "react";
import { StateView } from "./StateView.js";
import { featureLabel } from "../lib/permissions.js";

export interface PermissionDeniedProps {
  /** 功能点 key（契约 `FEATURE_POINTS` 的 key）；未登记时文案回落成 key 本身。 */
  readonly featureKey: string;
  /**
   * 服务端原始错误码（`FORBIDDEN` 等）：**只进 tooltip**，绝不进正文
   * （用户口径：不要显示原始错误码）。
   */
  readonly detailCode?: string | null;
}

export function PermissionDenied({ featureKey, detailCode = null }: PermissionDeniedProps): ReactElement {
  const label = featureLabel(featureKey);
  return (
    <div
      data-permission-denied={featureKey}
      {...(detailCode === null ? {} : { title: `诊断码：${detailCode}（仅供排障）` })}
    >
      <StateView
        kind="empty"
        title={`权限不足：${label}`}
        description={`你的账号没有「${label}」的访问权限。请联系管理员为你的账号开通该功能（或只读权限）。`}
        actionLabel={null}
        onAction={null}
      />
    </div>
  );
}
